import { NavLink } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Place } from 'shared/topchef.types';


export interface BriefsMarketMenuProps {
  loggedInPlace: Place
}

const BriefsMarketMenu = (props: BriefsMarketMenuProps) => {
  const { t } = useTranslation();

  return (
    <ul id="briefsTabs" className="nav nav-underline" style={{marginBottom: 20}}>
      <li className="nav-item" role="presentation">
        <NavLink to="/places/shared-leads" className="nav-link" id="briefs_sended_tab"  type="button"  aria-controls="briefs_sended" >
          {t('briefsMenu.sharedBriefs')}
        </NavLink>
      </li>
      <li className="nav-item" role="presentation">
        <NavLink to="/places/available-leads" className="nav-link" id="briefs_available_tab"  type="button"  aria-controls="briefs_available" >
          {t('briefsMenu.availableBriefs')}
        </NavLink>
      </li>
      {props.loggedInPlace.acceptReward && 
      <>
        <li className="nav-item" role="presentation">
          <NavLink to="/places/leads/followed" className="nav-link" id="briefs_in_progress_tab"  type="button"  aria-controls="briefs_in_progress_tab" >
          {t('briefsMenu.briefsToProcess')}
          </NavLink>
        </li>
        <li className="nav-item" role="presentation">
          <NavLink to="/places/leads/to-close" className="nav-link" id="briefs_to_close_tab"  type="button"  aria-controls="briefs_to_close_tab" >
          {t('briefsMenu.signedBriefsToClose')}
          </NavLink>
        </li>
      </>}
      {props.loggedInPlace.acceptReward ===false &&
      <li className="nav-item" role="presentation">
        <NavLink to="/places/leads/followed" className="nav-link" id="briefs_in_progress_tab"  type="button"  aria-controls="briefs_in_progress_tab" >
        {t('briefsMenu.followedBriefs')}
        </NavLink>
      </li>
      } 

    </ul>
  );

}

export default BriefsMarketMenu;
